
<div class="container  align-items-center">
    <!-- <div class="card card-container  "> -->
    <div class="card-header" [ngStyle]="{'background-color': onderneming?.kleur }">
    </div>
    <div class="">
        <div class="row">
            <h1 class="col-10 cardHeader card-title text-left"><strong>Horeca aanwerf calculator</strong></h1>
            <div class="col-2 text-right mt-2">
              <a class="backButton" [routerLink]="['/',onderneming.naam,'tools']">
                <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
              </a>
              
            </div>
           
          </div>
        <h6 class="card-subtitle mb-5 mobileTussentitel text-muted text-left">Simulatie voor de horeca welk profiel het interessants is om
            aan te werven</h6>
        <div class="row">

            <div class="col-12">
                <form [formGroup]="aanwerfFormGroup" (ngSubmit)="onSubmit();">
                    <div class="form-row">
                        <div class="form-group  col-md-6 ">
                            <label class="font-weight-bold" for="brutoUurloon">BRUTO
                                UURLOON<i placement="top" ngbTooltip={{aanwerfsimulator?.tekstBrutoUurloon}}
                                    class="fa size-tooltip-icon color-tooltip-icon fa-question-circle ml-1"  aria-hidden="true"></i></label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">€</span>
                                </div>
                                <input formControlName="brutoUurloon" type="number" name="brutoUurloon" step="any"
                                    placeholder="0.00" min=0 class="form-control" required>
                            </div>
                        </div>
                        <!-- <div class = "col-md-1"></div> -->
                        <div class="form-group  col-md-6 ">
                            <label class=" font-weight-bold" for="aantalUren">AANTAL
                                UREN / DAG</label>
                              

                            <input formControlName="aantalUren" type="number" name="aantalUren" step="any"
                                placeholder="0.00" min=0 class="form-control " required>
                                <div class="text-danger md-1" *ngIf=" aanwerfFormGroup.controls.aantalUren.errors?.max  ">
                                    Het maximaal aantal uren dat u kunt ingeven is 11.
                                </div>

                        </div>
                    </div>
                    <div class="text-right">
                        <button type="submit" [disabled]="!aanwerfFormGroup.valid"
                            class="btn btn-outline-secondary m-1">BEREKEN</button>
                    </div>

                </form>
            </div>

        </div>
        <div class="row">
            <div class="col mobile mt-5">
                <div *ngIf="!calculate" class="d-flex text-center w-100 h-100 " style="min-width: auto; min-height: 6em;">
                    <div class="card-body d-flex align-items-center ">
                      <p class="placeholder text-center w-100">vul het formulier in om resultaat te krijgen.</p>
                    </div>
                  </div>

                <div *ngIf="calculate" class="row">
                    <div class=" col-12">
                        <div class="table-responsive my-auto">

                            <table style="width:  100%;" class="table border">

                                <thead class="text-center thema">
                                    <tr class="thema">
                                        <th scope="col"></th>
                                        <th scope="col">Student</th>
                                        <th scope="col">Flexi job</th>
                                        <th scope="col">Extra</th>
                                        <th scope="col">Vaste medewerker</th>
                                    </tr>
                                </thead>
                                <tbody class="text-center">
                                    <tr>
                                        <th class="text-left" scope="row">Basisuurloon</th>
                                        <td class="col-tab">{{student.basisuurloon| currency:'EUR'| removeComma }}</td>
                                        <td class="col-tab">{{flexiJob.basisuurloon| currency:'EUR'| removeComma }}<i
                                                placement="top" ngbTooltip={{aanwerfsimulator?.tekstBasisUurloon}}
                                                class="fa fa-question-circle ml-1" aria-hidden="true"></i></td>
                                        <td class="col-tab">{{extra.basisuurloon| currency:'EUR'| removeComma }}</td>
                                        <td class="col-tab">{{vastMedewerker.basisuurloon| currency:'EUR'| removeComma }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Bruto</th>
                                        <td class="col-tab">{{student.bruto| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.bruto| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.bruto| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.bruto| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Basis berekening RSZ</th>
                                        <td class="col-tab">{{student.basisBerekeningRSZ| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.basisBerekeningRSZ| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.basisBerekeningRSZ| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.basisBerekeningRSZ| currency:'EUR'| removeComma}}
                                        </td>

                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Inhouding RSZ werknemer</th>
                                        <td class="col-tab">{{student.inhoudingRSZWerknemer| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.inhoudingRSZWerknemer| currency:'EUR'| removeComma}}
                                        </td>
                                        <td class="col-tab">{{extra.inhoudingRSZWerknemer| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">
                                            {{vastMedewerker.inhoudingRSZWerknemer| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Werkbonus</th>
                                        <td class="col-tab">{{student.werkbonus| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.werkbonus| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.werkbonus| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.werkbonus| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Belastbaar</th>
                                        <td class="col-tab">{{student.belastbaar| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.belastbaar| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.belastbaar| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.belastbaar| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Inhouding bv</th>
                                        <td class="col-tab">{{student.inhoudingBv| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.inhoudingBv| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.inhoudingBv| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.inhoudingBv| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Netto</th>
                                        <td class="col-tab">{{student.netto| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.netto| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.netto| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.netto| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr class="table-secondary">
                                        <th class="text-left" scope="row">Netto per uur</th>
                                        <td class="result col-tab">{{student.nettoPerUur| currency:'EUR'| removeComma}}</td>
                                        <td class="result col-tab">{{flexiJob.nettoPerUur| currency:'EUR'| removeComma}}</td>
                                        <td class="result col-tab">{{extra.nettoPerUur| currency:'EUR'| removeComma}}</td>
                                        <td class="result col-tab">{{vastMedewerker.nettoPerUur| currency:'EUR'| removeComma}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Totaal bijdrage werkgever</th>
                                        <td class="col-tab">{{student.totaalBijdragenWerkgever| currency:'EUR'| removeComma}}
                                        </td>
                                        <td class="col-tab">{{flexiJob.totaalBijdragenWerkgever| currency:'EUR'| removeComma}}
                                        </td>
                                        <td class="col-tab">{{extra.totaalBijdragenWerkgever| currency:'EUR'| removeComma}}
                                        </td>
                                        <td class="col-tab">
                                            {{vastMedewerker.totaalBijdragenWerkgever| currency:'EUR'| removeComma}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th class="text-left ondertitel" scope="row">RSZ Werkgever</th>
                                        <td class="col-tab">{{student.rszWerkgever| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.rszWerkgever| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.rszWerkgever| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.rszWerkgever| currency:'EUR'| removeComma}}</td>
                                    </tr>

                                    <tr>
                                        <th class="text-left ondertitel" scope="row">Fonds horeca<i placement="top"
                                                ngbTooltip={{aanwerfsimulator?.tekstFondsHoreca}}
                                                class="fa fa-question-circle color-tooltip-icon ml-1" aria-hidden="true"></i></th>
                                        <td class="col-tab">{{student.fondsHoreca| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.fondsHoreca| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.fondsHoreca| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.fondsHoreca| currency:'EUR'| removeComma}}</td>
                                    </tr>

                                    <tr>
                                        <th class="text-left ondertitel" scope="row">Jaarlijkse vakantie</th>
                                        <td class="col-tab">{{student.jaarlijkseVakantie| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.jaarlijkseVakantie| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.jaarlijkseVakantie| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.jaarlijkseVakantie| currency:'EUR'| removeComma}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="text-left" scope="row">Totale loonkost</th>
                                        <td class="col-tab">{{student.totaleLoonkost| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{flexiJob.totaleLoonkost| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{extra.totaleLoonkost| currency:'EUR'| removeComma}}</td>
                                        <td class="col-tab">{{vastMedewerker.totaleLoonkost| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                    <tr class="table-secondary">
                                        <th class="text-left" scope="row">Loonkost per uur</th>
                                        <td class="result col-tab">{{student.loonkostPerUur| currency:'EUR'| removeComma}}</td>
                                        <td class="result col-tab">{{flexiJob.loonkostPerUur| currency:'EUR'| removeComma}}</td>
                                        <td class="result col-tab">{{extra.loonkostPerUur| currency:'EUR'| removeComma}}</td>
                                        <td class="result col-tab">
                                            {{vastMedewerker.loonkostPerUur| currency:'EUR'| removeComma}}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <!--Op aanvraag van besox: knop met "Vraag offerte aan" -->
          <div *ngIf="onderneming.naam == 'Besox'" class="w-100 horizontalCenter d-flex mb-3">
            <div class="  ">
              <a type="button" href="https://www.besox.be/offerte-aanvragen/" class="pt-3 pb-3 btn btn-info btnOfferte">Vraag
                offerte aan</a>

            </div>
          </div>
                </div>
            </div>

        </div>

    </div>
    <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming?.kleur }"></div>
    <div class=" mt-4 row   h-100">
        <p class="text-center mx-auto font-italic">
            {{dataService.onderneming?.algemeneWaarschuwing }}
        </p>
    </div>
    <!-- </div> -->
</div>